import { useContext } from "react";
import AppContext from "../context/appProvider";

const useApp = () => {
  return useContext(AppContext);
};

export default useApp;
